import * as api from '../../api'

const state = {}

const getters = {}

const actions = {
  createExportFile ({ commit, rootGetters }, fileExport) {
    let formData = new FormData()
    formData.append('site_id', rootGetters.scopedSiteId)
    formData.append('import_type', fileExport.type)

    api.instance.post('file_export', formData, { 'content-type': 'multipart/form-data' })
      .then(function (response) {
        if (response.data.success === 'true') {
          let fileName = 'export_schedule.csv'

          if (fileExport.type === 'device') {
            fileName = 'export_device.csv'
          }

          window.open(location.origin + '/upload/files/' + fileName, '_blank')
        } else {
          alert(response.data.message)
        }
      })
  }
}

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}
